import DashboardTeam from "./Team";

export default DashboardTeam;
